import React from 'react';
import {render} from 'react-dom';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import App from './containers/App';
import Dashboard from 'components/Dashboard';
import createSagaMiddleware from 'redux-saga';
import {Provider} from 'react-redux';
import {reducer as toastrReducer} from 'react-redux-toastr';
import {composeWithDevTools} from 'redux-devtools-extension';
import bowser from 'bowser';

import 'bootstrap/dist/css/bootstrap.css';
import 'material-icons/css/material-icons.css';

import * as reducers from './redux/_commons/reducers';
import rootSaga from './redux/_commons/sagas';

import 'react-redux-toastr/src/less/index.less';
import 'font-awesome/css/font-awesome.css';


/* The IE 10 or less case */
if (bowser.msie && bowser.version < 11) {
  document.getElementById('app').innerHTML = `
    <div style="margin: 50px 0 0 30px">
      <span>Votre navigateur n'est pas supporté. Merci d'utiliser un des navigateurs suivants :</span>
      <ul style="margin-top: 30px">
	      <li>Internet Explorer 11</li>
	      <li>Microsoft Edge</li>
	      <li>Google Chrome</li>
	      <li>Mozilla Firefox</li>
	      <li>Opera</li>
	      <li>Safari 6 ou plus</li>
      </ul>
    </div>
  `;
  throw new Error('Browser not supported');
}

const reducer = combineReducers({
  ...reducers,
  toastr: toastrReducer
});

const sagaMiddleware = createSagaMiddleware();


const store = createStore(reducer, composeWithDevTools(
  applyMiddleware(sagaMiddleware),
  // other store enhancers if any
));

sagaMiddleware.run(rootSaga);

render(
  <Provider store={store}>
    <App>
      <Dashboard/>
    </App>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js